import { Link } from 'react-router-dom';

// Standard page header: serif title, muted subtitle, actions on the right,
// optional back link above the title. Replaces the per-screen inline <h1>s so
// every screen leads with the same voice.
const PageHeader = ({ title, subtitle, actions, backTo, backLabel }) => (
  <div className="table-toolbar">
    <div style={{ minWidth: 0 }}>
      {backTo && (
        <Link
          to={backTo}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '6px',
            marginBottom: '8px',
            fontFamily: 'var(--font-sans)', fontSize: '13px', fontWeight: 500,
            color: 'var(--muted)', textDecoration: 'none',
          }}
          onMouseOver={e => { e.currentTarget.style.color = 'var(--ink)'; }}
          onMouseOut={e => { e.currentTarget.style.color = 'var(--muted)'; }}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
          </svg>
          {backLabel || 'Back'}
        </Link>
      )}
      <h1 className="page-title">{title}</h1>
      {subtitle && <p className="page-subtitle">{subtitle}</p>}
    </div>
    {actions && (
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
        {actions}
      </div>
    )}
  </div>
);

export default PageHeader;
